import { FC, useContext, useEffect, useMemo } from 'react';
import { QUERY_userProfilePage } from 'queries';
import { createGQLDataContext } from 'utils/createDataContext';
import { useGQLQuery } from 'hooks';
import { GQLAPIContextType } from '@awais4123/fillify-design-library/lib/common.types';
import { UserProfilePageQuery } from 'types/graphql';

const UserProfilePageDataContext = createGQLDataContext<GQLAPIContextType<UserProfilePageQuery>>();

export const UserProfilePageDataProvider: FC = ({ children }) => {
  const { data, fetch, ...restQuery } = useGQLQuery({
    key: 'USER_PROFILE_PAGE',
    query: QUERY_userProfilePage,
    variables: {},
  });

  useEffect(() => {
    fetch();
  }, []); // eslint-disable-line

  const contextValue = useMemo(() => ({ data, fetch, ...restQuery }), [data, fetch, restQuery]);

  return (
    <UserProfilePageDataContext.Provider value={contextValue}>
      {children}
    </UserProfilePageDataContext.Provider>
  );
};

export const useUserProfilePageDataContext = (): GQLAPIContextType<UserProfilePageQuery> =>
  useContext(UserProfilePageDataContext);
